<template>
  <div
    class="modal fade"
    id="create-memorandum-modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <div>
              <h5 class="modal-title mb-0">
                {{ editMode ? "Update Memorandum" : "Issue New Memorandum" }}
              </h5>
              <small class="text-muted">
                Upload the soft copy (PDF) — it will be stored on Google Drive.
              </small>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label><span class="text-danger">*</span> Title / Subject</label>
              <textarea
                v-model="form.title"
                class="form-control"
                rows="3"
                placeholder="Enter memorandum title"
                required
              ></textarea>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label><span class="text-danger">*</span> Type</label>
                <select v-model="form.type" class="form-control" required>
                  <option value="office">Office Memorandum</option>
                  <option value="hei">HEI Memorandum</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label><span class="text-danger">*</span> Date Issued</label>
                <input
                  v-model="form.date_issued"
                  type="date"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="form-group">
              <label>Recipient</label>
              <input
                v-model="form.recipient"
                type="text"
                class="form-control"
                placeholder="e.g. ALL HEIs"
              />
            </div>
            <div class="form-group mb-0">
              <label
                ><span class="text-danger" v-if="!editMode">*</span> Soft Copy
                (PDF)</label
              >
              <div class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  id="memo-file-input"
                  accept=".pdf,application/pdf"
                  @change="onFileChange"
                />
                <label class="custom-file-label" for="memo-file-input">
                  {{ selectedFile ? selectedFile.name : "Choose PDF file" }}
                </label>
              </div>
              <small v-if="editMode && existingPath" class="form-text text-muted">
                Leave empty to keep the current file on Drive.
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span>
              {{ editMode ? "Save Changes" : "Issue Memorandum" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateMemorandumModal",
  data() {
    return {
      editMode: false,
      editingId: null,
      saving: false,
      selectedFile: null,
      existingPath: "",
      form: {
        title: "",
        type: "office",
        recipient: "",
        date_issued: "",
      },
    };
  },
  methods: {
    resetForm() {
      this.form = {
        title: "",
        type: "office",
        recipient: "",
        date_issued: new Date().toISOString().slice(0, 10),
      };
      this.selectedFile = null;
      this.existingPath = "";
      this.editingId = null;
      this.editMode = false;
      const input = document.getElementById("memo-file-input");
      if (input) input.value = "";
    },
    openCreate() {
      this.resetForm();
      $("#create-memorandum-modal").modal("show");
    },
    openEdit(memo) {
      this.editMode = true;
      this.editingId = memo.id;
      this.existingPath = memo.path || "";
      this.form = {
        title: memo.title || "",
        type: memo.type || "office",
        recipient: memo.recipient || "",
        date_issued: memo.date_issued
          ? memo.date_issued.slice(0, 10)
          : "",
      };
      this.selectedFile = null;
      $("#create-memorandum-modal").modal("show");
    },
    onFileChange(e) {
      this.selectedFile = e.target.files[0] || null;
    },
    submit() {
      if (!this.editMode && !this.selectedFile) {
        toastr.error("Please attach a PDF file.", "Error");
        return;
      }

      this.saving = true;
      const formData = new FormData();
      formData.append("title", this.form.title);
      formData.append("type", this.form.type || "office");
      formData.append("recipient", this.form.recipient || "");
      formData.append("date_issued", this.form.date_issued);
      if (this.selectedFile) {
        formData.append("file", this.selectedFile);
      }
      if (this.editMode) {
        // POST + _method so PHP parses multipart fields (PUT + FormData does not).
        formData.append("_method", "PUT");
      }

      const request = this.editMode
        ? axios.post(`api/memorandums/${this.editingId}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        : axios.post("api/memorandums", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

      request
        .then((res) => {
          toastr.success(
            (res.data && res.data.message) || "Saved successfully.",
            "Information"
          );
          $("#create-memorandum-modal").modal("hide");
          this.$emit("saved");
        })
        .catch((error) => {
          const message =
            (error.response && error.response.data.message) ||
            "Something went wrong.";
          toastr.error(message, "Error");
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
